import { capitalizeFirst } from "@/shared/text/capitalizeFirst";

export type HealthStatusColor = "success" | "error" | "warning" | "default";

/** A raw status or probe token as display text, underscores as spaces and the first letter capitalized: "unhealthy" -> "Unhealthy", "assume_role" -> "Assume role". */
export function formatHealthToken(token: string): string {
  return capitalizeFirst(token.replace(/_/g, " "));
}

export function healthStatusColor(status: string): HealthStatusColor {
  switch (status) {
    case "healthy":
      return "success";
    case "unhealthy":
      return "error";
    case "unknown":
      return "warning";
    case "unverified":
    default:
      return "default";
  }
}

/** Canonical order the probes run in, so the dialog lists them in a stable, meaningful sequence. */
export const PROBE_ORDER = [
  "assume_role",
  "location",
  "list",
  "put",
  "get",
  "delete",
] as const;
